import { Component, OnInit } from '@angular/core';
import { UsLife } from "../../../models/us-life.model";

@Component({
  selector: 'app-us-life',
  templateUrl: './us-life.component.html',
  styleUrls: ['./us-life.component.css']
})
export class UsLifeComponent implements OnInit {

  usLifes: UsLife[] = [
    {
      'imgName': 'checklist.png',
      'fileName': 'CheckList.pdf',
      'title': '赴美清单',
      'desc': '每年8月9月很多同学即将要踏上美国的国土，踏上他们新一段的人生旅途。在这里整理一下赴美留学物品清单'
    },
    {
      'imgName': 'credit-card.png',
      'fileName': 'CreditCard.pdf',
      'title': '信用卡',
      'desc': '在美国生活，信用卡是一个有趣且高效的省钱方式。只要投入很少的精力申请信用卡，就可以轻松地每年获得一张回国往返机票；若喜欢上了这个爱好认真钻研，则可以免费体验豪华的头等舱、高端酒店和机场休息室。本文的目的是给信用卡新手一个提纲挈领的玩卡入门攻略。'
    },
    {
      'imgName': 'flight-tickets.png',
      'fileName': 'FlightTickets.pdf',
      'title': '机票',
      'desc': '美国机票怎么买最便宜？最便宜的机票秘籍: 提前！提前！提前！对于国外航班，从美国出发的国际机票购买，最好提前3~6个月购买。一般国际航班，从提前6个月到提前3个月都维持着较低的价格，在临近航班起飞时间的两个月内票价急剧上升。尤其是欧洲、亚洲的机票，往往需要提前很久预定才能得到比较好的折扣。 '
    },
    {
      'imgName': 'mobile.png',
      'fileName': 'MobileTips.pdf',
      'title': '手机套餐',
      'desc': '美帝手机号哪家强？看完你就知道啦! 刚来美国，手机是必不可少的工具，初来乍到，什么都不知道的情况下容易人云亦云。本文的目的就是给各位刚来美国的留学生们提供最全面的手机套餐攻略。'
    },
    {
      'imgName': 'shopping.png',
      'fileName': 'Shopping.pdf',
      'title': '购物篇',
      'desc': '对于即将要来美国上学的同学来说，应该都比较关心哪里可以购物怎么购物，这篇文章就是介绍美国各类物品的购物渠道。 '
    },
    {
      'imgName': 'transport.png',
      'fileName': 'Transport.pdf',
      'title': '交通',
      'desc': '对于即将踏上到美国留学的同学们来说，美国的交通问题也是同学们关注的重点，今天就介绍一下美国各地区的交通问题，以及关于驾照的问题。 '
    },
    {
      'imgName': 'textbook.png',
      'fileName': 'Textbook.pdf',
      'title': '课本资源',
      'desc': '赴美留学，帮你课本费用节省一个亿! 不管通过什么途径购买教材，都要“价”比三家，多去几家书店对比一下价格，免得在店A买了书之后去了店B又看到更便宜，还要再回去A退书...想想就觉得很麻烦~所以小编并不是特别推荐在店里买书'
    },
    {
      'imgName': 'furniture.jpg',
      'fileName': 'Furniture.pdf',
      'title': '家居用品',
      'desc': '美国租房不知道怎么装修？最全家装店铺总结攻略初到美国，远离了高中或大学的宿舍，你可能会和好友租一个大house，也有可能搬入了公寓。买家具布置新家是必不可少的一步。下面是一份小编为大家整理的美帝的各品牌家具的购买攻略。 '
    }
  ]
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/components/us-life/us-life/us-life.component.ts